module.exports = __webpack_public_path__ + "img/finance-commercial-building.6ad4cc65.png";